import { useEffect, useMemo, useState } from "react";
export function useTxnExpiry(expiredAt) {
    var _a = useState(""), timeRemaining = _a[0], setTimeRemaining = _a[1];
    useEffect(function () {
        if (!expiredAt) {
            setTimeRemaining("");
            return;
        }
        var calculateTimeRemaining = function () {
            var now = new Date().getTime();
            var expiryMs = Date.parse(expiredAt);
            if (!Number.isFinite(expiryMs)) {
                setTimeRemaining("");
                return;
            }
            var difference = expiryMs - now;
            if (difference <= 0) {
                setTimeRemaining("Expired");
                return;
            }
            var hours = Math.floor(difference / (1000 * 60 * 60));
            var minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
            var seconds = Math.floor((difference % (1000 * 60)) / 1000);
            if (hours > 0) {
                setTimeRemaining("".concat(hours, "h ").concat(minutes, "m ").concat(seconds, "s"));
            }
            else if (minutes > 0) {
                setTimeRemaining("".concat(minutes, "m ").concat(seconds, "s"));
            }
            else {
                setTimeRemaining("".concat(seconds, "s"));
            }
        };
        calculateTimeRemaining();
        var interval = setInterval(calculateTimeRemaining, 1000);
        return function () { return clearInterval(interval); };
    }, [expiredAt]);
    var showUnExpiredContent = useMemo(function () { return timeRemaining !== "Expired"; }, [timeRemaining]);
    return { timeRemaining: timeRemaining, showUnExpiredContent: showUnExpiredContent };
}
